import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-compact-right', 'IconChevronCompactRight', [["path",{"d":"M11 4l3 8l-3 8","key":"svg-0"}]]);